'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = accessors;
var _ramda = require('ramda');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    areas: function areas(data) {
      return (0, _ramda.pathOr)({}, ['objects', 'areas'], data);
    },
    areaColor: function areaColor(options) {
      return (0, _ramda.path)(['map', 'defaultAreaColor'], options);
    },
    id: function id(d) {
      return (0, _ramda.pathOr)(null, ['properties', 'id'], d);
    },
    label: function label(d) {
      return (0, _ramda.pathOr)(null, ['properties', 'label'], d);
    },
    scale: function scale(options) {
      return (0, _ramda.path)(['map', 'scale'], options);
    },
    width: function width(options) {
      return (0, _ramda.path)(['base', 'width'], options);
    },
    height: function height(options) {
      return (0, _ramda.path)(['base', 'height'], options);
    },
    extBoundariesColor: function extBoundariesColor(options) {
      return (0, _ramda.path)(['map', 'extBoundariesColor'], options);
    },
    extBoundariesThickness: function extBoundariesThickness(options) {
      return (0, _ramda.path)(['map', 'extBoundariesThickness'], options);
    },
    extBoundariesDisplay: function extBoundariesDisplay(options) {
      return (0, _ramda.path)(['map', 'extBoundariesDisplay'], options);
    },
    intBoundariesColor: function intBoundariesColor(options) {
      return (0, _ramda.path)(['map', 'intBoundariesColor'], options);
    },
    intBoundariesThickness: function intBoundariesThickness(options) {
      return (0, _ramda.path)(['map', 'intBoundariesThickness'], options);
    },
    intBoundariesDisplay: function intBoundariesDisplay(options) {
      return (0, _ramda.path)(['map', 'intBoundariesDisplay'], options);
    },
    innerPadding: function innerPadding(options) {
      return (0, _ramda.path)(['map', 'innerPadding'], options);
    },
    projection: function projection(options) {
      return (0, _ramda.path)(['map', 'projection'], options);
    }
  });
}